var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["LogoItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["l"], 
[], 
function (l_l, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("l", l_l);
var t_2 = "";t_2 += "<div class=\"LogoItem\">\n        <img src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_l),"img")),"main"), env.opts.autoescape);
t_2 += "\"\n             srcset=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_l),"img")),"main_2x"), env.opts.autoescape);
t_2 += " 2x\"\n             alt=\"Логотип\">\n    </div>";
t_2 += runtime.suppressValue((lineno = 5, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("LogoItem");
context.setVariable("LogoItem", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["LogoItem.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/LogoItem/LogoItem.jinja
// module id = 99
// module chunks = 0